import React, { useEffect, useId, useState } from "react";
import { Link, redirect, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardText,
  CardTitle,
  Col,
  Modal,
  Row,
} from "reactstrap";

import profileImg from "../../../assets/images/profile-img.png";
import manProfile from "../../../assets/images/man_profile.png";
import womanProfile from "../../../assets/images/woman_profile.png";
import axios from "axios";
import { GetCookieData, GetCookieToken } from "../../Cookie/GetCookie";
import { checkBudgetYear } from "../../Function/CheckBudgetYear";
import EditData from "../../SetData/officer/EditData";
import ModalConID from "../../SetData/ModalConID";
import OrganizationChart from "./OrganizationChart";
import { CheckSubAdmin } from "../../Function/CheckSubAdmin";

const WelcomeComp = ({
  userId,
  name,
  email,
  picture,
  user_gender,
  currentBudgetYear,
}) => {
  
  const baseURL = process.env.REACT_APP_API_CORS;
  const token = GetCookieToken("userToken");
  const user = GetCookieData("userData");
  const user_id = user?.user_id;
  //Get Leave Day of Any Type
  const [dataChart, setDataChart] = useState();
  const [lateEntry, setLateEntry] = useState();

  const checkPicNullAndGender = (gender) => {
    if (!picture && gender === "นาย") return manProfile;
    if (!picture && gender === "นาง") return womanProfile;
    if (!picture && gender === "นางสาว") return womanProfile;
    else {
      if (picture && picture.startsWith("./public")) {
        return baseURL + picture.replace("./public", "")
      } else {
        return picture
      }
    }
  };

  const getLeaveChart = async () => {
    try {
      const res = await axios.get(
        baseURL + `/api/leave/chart/1/${currentBudgetYear}/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setDataChart(res?.data?.result);
    } catch (err) {
      console.error(err);
    }
  };

  const getEntryLate = async () => {
    try {
      const url = `${baseURL}/api/time/history`;
      const params = new URLSearchParams({
        page: 1,
        size: 365,
        "order[0]": "scan_date",
        "order[1]": "DESC",
        "filter[user_id][0]": user_id,
        "filter[budget_year][0]": currentBudgetYear,
        "filter[late][0]": "1",
        "filter[late][1]": "2",
        "filter[late][2]": "3",
      });
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      const res = await axios.get(url, config);
      setLateEntry((prev) => res?.data?.info?.totalRows);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getLeaveChart();
    getEntryLate();
  }, []);

  const statFontSize = {fontSize: "15px"}

  return (
    <React.Fragment>
      <Card className="overflow-hidden">
        <div className="bg-primary bg-soft">
          <Row>
            <Col xl={8} xs="7">
              <div className="text-primary p-3">
                <h3 className="text-primary">ยินดีต้อนรับเข้าสู่</h3>
                <h4>สำนักงาน ก.พ.ร.</h4>
              </div>
            </Col>
            <Col
              xl={4}
              xs="5"
              className="d-flex justify-content-end align-self-end"
            >
              <img
                src={profileImg}
                alt=""
                className="img-fluid wel-background"
              />
              {/* <img src={profileImg} alt="" className="img-fluid" /> */}
            </Col>
          </Row>
        </div>
        <CardBody className="pt-0">
          <Row className="d-flex align-items-center">
            <Col xxl={9} xs={10}>
              <Row className="d-flex align-items-center">
                <Col sm={4} xs={4} className="d-flex justify-content-center">
                  <div
                    className="wel-img avatar-lg profile-user-wid mb-4"
                    // style={{width:"100px",height:"100px"}}
                  >
                    <img
                      src={checkPicNullAndGender(user_gender)}
                      alt=""
                      className="img-fluid img-thumbnail rounded-circle"
                      // style={{width:"100%", height:"100%"}}
                      //
                    />
                  </div>
                </Col>
                <Col xxl={8} sm={8} xs={8} className="text-start">
                  <h5 className="text-truncate">
                    {name}
                  </h5>
                  <p className="text-muted mb-0 text-truncate font-size-14">
                    {email}
                  </p>
                </Col>
              </Row>
            </Col>
            <Col xxl={3} xs={2} className="d-flex justify-content-end">
              <EditData id = {user_id} selectButton = {2}/>
              {/* <Link
                to={`/setdata?user=${user_id}`}
                className={`btn btn-primary btn-md font-size-12`}
              >
                <i className="fa-solid fa-pen"></i>
              </Link> */}
              {/* </div> */}
            </Col>
            {CheckSubAdmin(user?.positionSubAdmin) 
              && (CheckSubAdmin(user?.positionSubAdmin)?.includes(0) || CheckSubAdmin(user?.positionSubAdmin)?.includes(5)) 
              && <Col xxl={{ offset: 9, size: 3 }} className="d-flex justify-content-end"> <OrganizationChart /> </Col> }
          </Row>
          <CardTitle>การลา / มาสาย</CardTitle>
          <Row
            className="mt-2"
            style={{ display: "flex", alignItems: "center" }}
          >
            <Col md={3} sm={3} xs={6}>
              <div className="wel-leave-contain">
                <div className="wel-leave-both">
                  <div
                    className="wel-leave-halftop"
                    style={{ background: "#FFCECE" }}
                  >
                    <i
                      className="wel-leave-icon fa-solid fa-heart-pulse"
                      style={{ color: "#B31800" }}
                    ></i>
                  </div>
                  <div className="wel-leave-halfbot">
                    <div className="text-center">
                      <h5 style={statFontSize} className="wel-leave-type py-0 my-0">ลาป่วย</h5>
                      <h5 style={statFontSize} className="wel-leave-number py-0 my-0">
                        <strong>
                          {dataChart
                            ? dataChart?.sick_limit_day?.use + " "
                            : "? "}
                          วัน
                        </strong>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3} sm={3} xs={6}>
              <div className="wel-leave-contain">
                <div className="wel-leave-both">
                  <div
                    className="wel-leave-halftop"
                    style={{ background: "#FFF3CE" }}
                  >
                    <div className="wel-leave-icon-background">
                      <i
                        className="wel-leave-icon fa-solid fa-briefcase"
                        style={{ color: "#C89600" }}
                      ></i>
                    </div>
                  </div>
                  <div className="wel-leave-halfbot">
                    <div className="text-center">
                      <h5 style={statFontSize} className="wel-leave-type py-0 my-0">ลากิจ</h5>
                      <h5 style={statFontSize} className="wel-leave-number py-0 my-0">
                        <strong>
                          {dataChart
                            ? dataChart?.personal_limit_day?.use + " "
                            : "? "}
                          วัน
                        </strong>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3} sm={3} xs={6}>
              <div className="wel-leave-contain">
                <div className="wel-leave-both">
                  <div
                    className="wel-leave-halftop"
                    style={{ background: "#DCFFCE" }}
                  >
                    <div className="wel-leave-icon-background">
                      <i
                        className="wel-leave-icon fa-solid fa-umbrella-beach"
                        style={{ color: "#40A800" }}
                      ></i>
                    </div>
                  </div>
                  <div className="wel-leave-halfbot">
                    <div className="text-center">
                      <h5 style={statFontSize} className="wel-leave-type py-0 my-0">ลาพักผ่อน</h5>
                      <h5 style={statFontSize} className="wel-leave-number vacation py-0 my-0">
                        <strong>
                          {dataChart
                            ? dataChart?.vacation_limit_day?.use + " "
                            : "?"}
                          /{" "}
                          {dataChart
                            ? dataChart?.years_worked >= 10
                              ? (dataChart?.vacation_limit_day?.max + (dataChart?.vacation_over10?.vacation_day_prev || 0)) > 30
                                ? 30 : dataChart?.vacation_limit_day?.max + (dataChart?.vacation_over10?.vacation_day_prev || 0)
                              : (dataChart?.vacation_limit_day?.max + (dataChart?.vacation_under10?.vacation_day_prev || 0)) > 20
                                ? 20 :  dataChart?.vacation_limit_day?.max + (dataChart?.vacation_under10?.vacation_day_prev || 0)
                            : "?"}{" "}
                          วัน
                        </strong>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
            <Col md={3} sm={3} xs={6}>
              <div className="wel-leave-contain">
                <div className="wel-leave-both">
                  <div
                    className="wel-leave-halftop"
                    style={{ background: "#CEFEFF" }}
                  >
                    <div className="wel-leave-icon-background">
                      <i
                        className="wel-leave-icon fa-solid fa-clock"
                        style={{ color: "#00BAAE" }}
                      ></i>
                    </div>
                  </div>
                  <div className="wel-leave-halfbot">
                    <div className="text-center">
                      <h5 style={{fontSize : "15px"}} className="wel-leave-type py-0 my-0">สาย</h5>
                      <h5 style={{fontSize : "15px"}} className="wel-leave-number py-0 my-0">
                        <strong>
                          {lateEntry === 0 &&
                          (lateEntry !== undefined || lateEntry !== null)
                            ? "0"
                            : lateEntry !== 0
                            ? lateEntry
                            : "? "}{" "}
                          วัน
                        </strong>
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </CardBody>
        {/* <CardFooter style={{ background: "#F0F0F0" }}>
          
        </CardFooter> */}
      </Card>
    </React.Fragment>
  );
};

export default WelcomeComp;
